import { Navigate, Outlet, useLocation } from 'react-router-dom';
import SignupHeader from 'components/Auth/SignupHeader';
import styled from 'styled-components';
import { media } from 'styles';
import { useSelector } from 'react-redux';
import useParentNeedsOnboarding from 'hooks/useParentNeedsOnboarding';

const SignupRoute = ({ noNavigation }) => {
  const location = useLocation();
  const isAuthenticated = useSelector(s => s.user.isAuthenticated);
  const isOnboardingRequired = useParentNeedsOnboarding();

  if (isOnboardingRequired === true && !location.pathname.includes('signup')) {
    return <Navigate to="/signup/parent" />;
  } else if (isAuthenticated && isOnboardingRequired === false) {
    return <Navigate to="/" replace />;
  }

  return (
    <Body>
      <SignupHeader noNavigation={noNavigation} />
      <Outlet />
    </Body>
  );
};

const Body = styled.div`
  min-height: 100vh;
  ${media.sm`
    background: linear-gradient(308.66deg, var(--indigo-light) 3.96%, var(--purple-light) 100%);
    background-size: cover;
  `}
`;

export default SignupRoute;
